import { Brand, createBranded } from '@deltasierra/type-utilities';
import { ActivityId } from '../activity';
import { HasId, FullAuditable } from '../common';
import { Platform, PlatformId } from '../platform/Platform';

export interface Channel extends HasId<ChannelId>, FullAuditable {
    label: string;
    isSelfService: boolean;
    isSupported: boolean;
    platformId: PlatformId | null;
    platform?: Platform;
    activityId: ActivityId;
}

export interface NewChannelData {
    label: string;
    platformId?: number | null;
    isSelfService: boolean;
    isSupported: boolean;
    activityId: number;
}

export interface DeleteChannelBody {
    replacementChannelId: number;
}

export type BasicChannelDto = Pick<Channel, 'id' | 'label'>;

export function sanitiseChannelLabel(channelLabel: string): string {
    return (channelLabel || '').trim();
}

export function isGeneralChannel(channel: Channel): boolean {
    return !channel.isSelfService && !channel.isSupported;
}

export type ChannelId = Brand<number, 'ChannelId'>;
export const ChannelId = createBranded<ChannelId>();
